import React from 'react';
import { graphql, PageProps } from 'gatsby';
import { VideoPoster } from '../components/pages';

type VideoPosterTemplateProps = Partial<PageProps> & {
  pageContext: any;
};

export default function VideoPosterTemplate({
  pageContext,
  location,
}: VideoPosterTemplateProps) {
  return <VideoPoster post={pageContext?.result ?? {}} />;
}
